import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { TenantList } from '@/components/admin/TenantList';
import { TenantFormDialog } from '@/components/admin/TenantFormDialog';
import { AdminUplogStats } from '@/components/admin/AdminUplogStats';

export function AdminTenantsPage() {
  const [showForm, setShowForm] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Clientes</h1>
          <p className="mt-1 text-sm text-muted-foreground">Gerencie os tenants da plataforma</p>
        </div>
        <Button onClick={() => setShowForm(true)}>
          <Plus className="h-4 w-4" />
          Novo cliente
        </Button>
      </div>

      <TenantList />
      <AdminUplogStats />
      <TenantFormDialog open={showForm} onOpenChange={setShowForm} />
    </div>
  );
}
